import React, { useEffect } from 'react'
import styles from "./Notification.module.scss"
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationData, readNotificationData, updateNotificationData } from '@redux/slices/notificationSlice';
import Loader from 'components/shared/loader/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import CampaignIcon from '@mui/icons-material/Campaign';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SchoolIcon from '@mui/icons-material/School';
import TaskIcon from '@mui/icons-material/Task';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { capitalizeFirstLetter, timeAgo } from 'utils/utils';
import { Button } from '@mui/material';
const NotificationContent = ({
    handleClose
}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { notification, loader } = useSelector((state) => state?.notification)
    const handleRead = () => {
        dispatch(updateNotificationData())
    }

    const handleIconRender = (moduleType) => {
        switch (moduleType) {
            case "announcement":
                return <CampaignIcon style={{ fontSize: "30px", color: "#2A72B9" }} />
            case "task":
                return <TaskAltIcon style={{ fontSize: "25px", color: "#2A72B9" }} />
            case "training":
                return <SchoolIcon style={{ fontSize: "25px", color: "#2A72B9" }} />
            case "trigger":
                return <TaskIcon style={{ fontSize: "25px", color: "#2A72B9" }} />
            default:
                return <NotificationsActiveIcon style={{ fontSize: "25px", color: "#2A72B9" }} />
        }
    }

    const dummmy = [
        {
            title: "New Announcement",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            moduleType: "announcement"
        },
        {
            title: "New Task",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            moduleType: "task"
        },
        {
            title: "New Project",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            moduleType: "project"
        }
    ]

    const handleNavigate = (moduleType, id) => {
        dispatch(readNotificationData(id))
        switch (moduleType) {
            case "announcement":
                navigate("/announcements")
                handleClose()
                break;
            case "task":
                navigate("/tasks")
                handleClose()
                break;
            case "project":
                navigate("/project")
                handleClose()
                break;
            case "training":
                navigate("/training")
                handleClose()
                break;
            case "trigger":
                navigate("/task")
                handleClose()
                break;
            default:
                navigate(location.pathname)
                handleClose()
                break;
        }
    }
    useEffect(() => {
        dispatch(getNotificationData())
    }, [])
    return (
        <>
            <div className={styles?.notificationContainer}>
                <div className={styles?.header}>
                    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                        <div><CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} /></div>
                        <h3>Notification Center</h3>
                    </div>
                       { notification?.length !== 0 ? <Button className={styles?.read} onClick={() => handleRead()}>MARK ALL AS READ</Button> : null }
                </div>
                <div className={styles?.notificationBody}>
                    {loader ? <div style={{ display: "flex", justifyContent: "center" }}>
                        <Loader />
                    </div> :
                        notification?.length ?
                            notification?.map((notify) => {
                                return <div key={notify?._id} className={styles?.notificationInner} onClick={() => handleNavigate(notify?.moduleType, notify?._id)}>
                                    <div style={{ marginRight: "10px" }}>
                                        {handleIconRender(notify?.moduleType) ||  "-"}
                                    </div>
                                    <div className={styles?.notificationText}>
                                        <div style={{ display: "flex" , flexDirection: "row" , justifyContent:"space-between",  fontSize:"14px" ,  margin: "0px", opacity: "0.5" }}><span>{capitalizeFirstLetter(notify?.moduleType)}</span> <span>{timeAgo(notify?.createdAt)}</span></div>
                                        <p className={ styles?.notificationTitle }>{notify?.title || "-"}</p>
                                        <p className={ styles?.notificationDescription } dangerouslySetInnerHTML={{ __html: notify?.message || "-" }} />
                                    </div>

                                </div>
                            })
                            :
                            <div style={{ marginTop:"120px"  ,  textAlign: "center" , fontFamily: " Arial, Helvetica, sans-serif" }}>
                        <div>
                            <NotificationsOffIcon style={{ fontSize: "125px", color: "#3E9EF7" }} /> </div>
                                No Notifications to display!
                            </div>
                    }


                </div>
            </div>

        </>
    )
}

export default NotificationContent